import { render } from "./SpeakEnglishTestItem.vue?vue&type=template&id=48c383b5&scoped=true"
import script from "./SpeakEnglishTestItem.vue?vue&type=script&lang=js"
export * from "./SpeakEnglishTestItem.vue?vue&type=script&lang=js"

import "./SpeakEnglishTestItem.vue?vue&type=style&index=0&id=48c383b5&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c383b5"]])

export default __exports__